import Axios from '../axios';
export class HomeApi {
    /**
     *  获取待办列表
     */
    searchWorkitems(params) {
        return Axios.get('/api/runtime/workflow/search_workitems', {
            params
        });
    }
    /**
     * 批量处理待办
     */
    batchUnfinishedWorkitem(params) {
        return Axios.post('/api/runtime/form/batchSubmit', params);
    }
    /**
     * 获取待阅
     */
    searchCirculates(params) {
        return Axios.get('/api/runtime/workflow/search_circulates', {
            params
        });
    }
    /**
     * 获取已办
     */
    getFinishedWorkitems(params) {
        return Axios.get('/api/runtime/workflow/list_finished_workitems', {
            params
        });
    }
    /**
     * 获取已阅
     */
    getFinishedCirculates(params) {
        return Axios.get('/api/runtime/workflow/list_finished_circulates', {
            params
        });
    }
    /**
     * 标记为已阅
     */
    updateCirculateReaded(circulateItemIds) {
        return Axios.post('/api/runtime/workflow/update_circulate_readed', {
            circulateItemIds
        });
    }
    /**
     * 获取待办，待阅数量
     */
    getWorkCount(appCode = '') {
        const params = {
            appCode
        };
        return Axios.get('/api/runtime/workflow/get_work_count', { params });
    }
}
;
